<template>
  <div class="account-settings">
    <h4> Настройки аккаунта </h4>

    <div class="settings-section">
      <div class="section-title">
        <span>E-mail</span>
        <div class="line"></div>
      </div>

      <div v-if="authState.userData.blockedActivityReason == 'noConfirmedEmail'">
        <div class="account-settings__confirm-email">
          <i class="bx bxs-info-circle account-settings__confirm-email-icon"/>
          <span>
            Необходимо подтверждение указанного почтового ящика {{ authState.userData.email }}. Ссылка на подтверждение была отправлена на ваш e-mail при регистрации
          </span>
        </div>

        <div v-if="initConfirmEmailMessageSent">
          Сообщение отправлено!
        </div>
        <div v-else>
          <button class="btn account-settings-btn" @click="handleInitConfirmEmail">Отправить сообщение повторно</button>
        </div>

      </div>
    </div>

    <!--    <div class="settings-section">-->
    <!--      <div class="section-title">-->
    <!--        <span>Безопасность</span>-->
    <!--        <div class="line"></div>-->
    <!--      </div>-->
    <!--      <div>настройки безопасности</div>-->
    <!--    </div>-->

  </div>
</template>

<script lang="ts">
import {defineComponent, ref} from "vue";
import authStore from "@/store/auth";

export default defineComponent({
  name: 'AccountSettingsPage',
  components: {},
  setup() {
    const {
      authState,
      initConfirmEmail,
      gRecaptchaKey
    } = authStore

    const initConfirmEmailMessageSent = ref(false)

    return {
      authState,
      initConfirmEmail,
      gRecaptchaKey,
      captchaToken: "",
      initConfirmEmailMessageSent
    }
  },
  methods: {
    async handleInitConfirmEmail() {
      await grecaptcha.ready(async () => {
        this.captchaToken = await grecaptcha.execute(this.gRecaptchaKey, {
          action: "login",
        });

        await this.initConfirmEmail(this.captchaToken, () => {
          this.initConfirmEmailMessageSent = true
        });
      });
    },
  }
})
</script>

<style scoped>
.account-settings__confirm-email-icon {
  margin-right: 5px;
  color: #d31515
}

.account-settings__confirm-email {
  border-radius: 0.25rem;
  padding: 20px;
  background: rgba(204, 204, 204, 0.1);
  margin-bottom: 2rem;
}

.settings-section {
  margin-bottom: 20px; /* Расстояние между секциями */
}

.section-title {
  display: flex;
  align-items: center;
  margin-bottom: .5rem;
}

.section-title span {
  font-weight: bold;
  margin-right: 10px; /* Отступ между текстом и линией */
}

.section-title .line {
  flex-grow: 1; /* Линия занимает оставшееся пространство */
  height: 1px;
  background-color: #18d26e; /* Зеленая линия */
}

.account-settings-btn {
  color: #000;
  background: #18d26e;
  margin-left: 10px;
}
</style>
